/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

import { SkeletonLoader } from '@ally/metronome-ui'

import { useTransmit } from '../../TransmitContext'

export const EnrollCustomer: React.FC = () => {
  const { actions } = useTransmit()
  const location = useLocation()
  const params = queryString.parse(location.search)

  useEffect(() => {
    actions.onlineEnrollment({
      journey_version: 'v2',
      enrollmentData: params.enrollmentData,
      enrollmentDataSource: params.enrollmentDataSource,
    })
  }, [])

  return (
    <SkeletonLoader.Container>
      <SkeletonLoader.Row height="m" width="s" />
      <SkeletonLoader.Row height="m" width="m" />
      <SkeletonLoader.Row height="xl" width="s" />
      <SkeletonLoader.Row height="xl" width="s" />
      <SkeletonLoader.Row height="xl" width="s" />
    </SkeletonLoader.Container>
  )
}
